// Public identifiers only. Approval and CMP readiness must be explicitly confirmed.
export function adsenseSettings(env:Record<string,string|undefined>){
 const publisher=env.VITE_ADSENSE_PUBLISHER_ID??'';
 const slot=env.VITE_ADSENSE_IN_FEED_SLOT??'';
 const layoutKey=env.VITE_ADSENSE_IN_FEED_LAYOUT_KEY??'';
 const configured=/^ca-pub-\d{16}$/.test(publisher);
 const nativeConfigured=/^\d{6,20}$/.test(slot)&&/^[A-Za-z0-9+_-]+$/.test(layoutKey);
 return {publisher,slot,layoutKey,configured,nativeConfigured,
  serving:configured&&env.VITE_ADSENSE_SITE_APPROVED==='true'&&env.VITE_ADSENSE_CMP_PUBLISHED==='true',
  // This records the intended dashboard configuration, not a show-interstitial API.
  vignettes:env.VITE_ADSENSE_VIGNETTES==='true'};
}
export type AdSenseSettings=ReturnType<typeof adsenseSettings>;
